export default __webpack_public_path__ + "static/media/PremierLight.1b8049c0.svg";